import { render, staticRenderFns } from "./EditOrNew.vue?vue&type=template&id=8ff84200&scoped=true&"
import script from "./EditOrNew.vue?vue&type=script&lang=js&"
export * from "./EditOrNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ff84200",
  null
  
)

export default component.exports